import { render, staticRenderFns } from "./SingularityTooltip.vue?vue&type=template&id=0a5712bc&"
import script from "./SingularityTooltip.vue?vue&type=script&lang=ts&"
export * from "./SingularityTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./SingularityTooltip.vue?vue&type=style&index=0&id=0a5712bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports